<template>
    <div class="ApplicationLoader" :aria-label="ariaLabel">
        <div
            class="basic-loader"
            :class="{
                'is-center': center,
            }"
            :style="styles"
        >
            <span class="basic-loader-item"></span>
            <span class="basic-loader-item"></span>
            <span class="basic-loader-item"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        center: { type: Boolean, default: false },
        height: { type: Number },
        ariaLabel: { type: String, default: 'GeneralLoadingAllTheThings' }
    },

    computed: {
        styles() {
            const styles = {};

            if (typeof this.height === 'number') {
                styles.height = `${this.height}px`;
            }

            return styles;
        },
    },
};
</script>
